/**
 * Get the URL parameters
 * source: https://css-tricks.com/snippets/javascript/get-url-variables/
 * @param  {String} url The URL
 * @return {Object}     The URL parameters
 */
export const getParams = function(url) {
  var params = {};
  var parser = document.createElement("a");
  parser.href = url;
  var query = parser.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair.length > 2 && pair[1] !== undefined && pair[1].includes("code")) {
      params[pair[0]] = decodeURIComponent(pair[1]) + "=" + pair[2];
    } else {
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
  }
  return params;
};

export const getURLParams = (string, prop) => {
  const a = document.createElement("a");
  a.setAttribute("href", string);
  const { host, hostname, pathname, port, protocol, search, hash } = a;
  const origin = `${protocol}//${hostname}${port.length ? `:${port}` : ""}`;
  return prop
    ? eval(prop)
    : { origin, host, hostname, pathname, port, protocol, search, hash };
};

/**
 * Get the sub Domain from the url
 * @param  {String} url The URL
 * @return {String} The URL parameters
 */
export const getSubDomain = function(hostname) {
  const parts = hostname.split(".");
  const sndleveldomain = parts.slice(0, 1).join("");
  return sndleveldomain;
};



// WEBPACK FOOTER //
// ./src/shared/util.js